export var FIELD_FONT_SIZE = 14;
export var FIELD_HEIGHT = '3.28em';
export var FIELD_INNER_PADDING = 16;
export var FIELD_SUBTEXT_FONT_SIZE = 12;
export var FIELD_SUBTEXT_HEIGHT = Math.ceil(2.16 * FIELD_SUBTEXT_FONT_SIZE);
export var FIELD_MARGIN_BOTTOM = FIELD_SUBTEXT_HEIGHT + 2;
export var FIELD_MARGIN_BOTTOM_SMALL = 12;
export var FIELD_DROPDOWN_MARGIN_TOP = -6;
export var PHONE_MASK = '+1 (###) ###-####';
export var SSN_MASK = '###-##-####';